import { forwardRef } from "react";

/**
 * Chrome-less, fluid layout for embedded (portal iframe) mode.
 *
 * No sidebar/header/grid: fills the portal column width and viewport height,
 * never overflows horizontally, and gives children a `flex-1 min-h-0` cell so
 * ChatInterface's internal `overflow-y-auto` keeps working. Forwards a ref on
 * the root for the postMessage bridge's ResizeObserver.
 */
const EmbedLayout = forwardRef<HTMLDivElement, { children: React.ReactNode }>(
  function EmbedLayout({ children }, ref) {
    return (
      <div
        ref={ref}
        className="w-full max-w-full min-w-0 h-screen flex flex-col overflow-x-hidden"
      >
        <div className="flex-1 min-h-0">{children}</div>
      </div>
    );
  },
);

export default EmbedLayout;
